import {
  SHOW_EMPLOYEE,
  SHOW_EMPLOYEE_SUCCESS,
  SHOW_EMPLOYEE_FAIL,
  UPDATE_PARTNER_SETTINGS_SUCCESS,
  SET_SIMULATED_PARTNER,
  CLEAR_SIMULATED_PARTNER,
} from '../actions/types';

const loadSimulatedPartner = () => {
  try {
    const stored = sessionStorage.getItem('simulated_deal_partner');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

const INITIAL_STATE = {
  employee: null,
  organization: null,
  deal_partner: null,
  simulated_deal_partner: loadSimulatedPartner(),
  loading: false,
  error: null,
};

export default function employeeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOW_EMPLOYEE:
      return { ...state, loading: true, error: null };
    case SHOW_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        employee: action.payload.employee,
        organization: action.payload.organization,
        deal_partner: action.payload.deal_partner || null,
        error: null,
      };
    case SHOW_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.error || 'Failed to fetch employee',
      };
    case UPDATE_PARTNER_SETTINGS_SUCCESS:
      return {
        ...state,
        deal_partner: action.payload.deal_partner,
      };
    case SET_SIMULATED_PARTNER:
      return {
        ...state,
        simulated_deal_partner: action.payload,
      };
    case CLEAR_SIMULATED_PARTNER:
      return {
        ...state,
        simulated_deal_partner: null,
      };
    default:
      return state;
  }
}
